import {Injectable, signal, WritableSignal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  progress: WritableSignal<{
    progress: number;
    message: string;
    inProgress: boolean;
  }> = signal({
    progress: 0,
    message: '',
    inProgress: false,
  });

  loading: WritableSignal<boolean> = signal(false);

  constructor() {
  }

  async setProgress(progress: number, message: string, inProgress: boolean) {
    this.progress.set({progress, message, inProgress});
    await new Promise((resolve) => setTimeout(resolve, 200));
  }
}
